var map = {
	"./Vector.svg": 773,
	"./add.svg": 774,
	"./arrow-left.svg": 775,
	"./arrow-leftt.svg": 776,
	"./arrow-orange.svg": 777,
	"./arrow-right.svg": 385,
	"./arrow-white.svg": 378,
	"./arrow.svg": 187,
	"./back.svg": 381,
	"./car.svg": 623,
	"./cart.svg": 242,
	"./chat.svg": 405,
	"./check-circle-success.svg": 778,
	"./check-circle.svg": 406,
	"./checked-green.svg": 382,
	"./checkmark.svg": 384,
	"./chevron-down.svg": 391,
	"./chosen.svg": 779,
	"./close-white.svg": 780,
	"./close.svg": 120,
	"./creditcards.svg": 622,
	"./delivery.svg": 624,
	"./edit.svg": 616,
	"./facebook.svg": 400,
	"./faq-icon-open.svg": 394,
	"./faq-icon.svg": 393,
	"./favorites-add.svg": 604,
	"./favorites-filled.svg": 608,
	"./favorites.svg": 250,
	"./filter.svg": 389,
	"./icon-next.svg": 601,
	"./icon-prev.svg": 781,
	"./instagram.svg": 401,
	"./kwanza.svg": 379,
	"./lev-big.svg": 625,
	"./lev.svg": 383,
	"./logo-footer.svg": 399,
	"./logo-mobile.svg": 395,
	"./logo-white.svg": 782,
	"./logo.svg": 783,
	"./logout.svg": 398,
	"./mail-feather.svg": 618,
	"./mail.svg": 626,
	"./map-arrow.svg": 387,
	"./map-pin.svg": 392,
	"./mastercard.svg": 784,
	"./mastercard_footer.svg": 403,
	"./mbway.svg": 246,
	"./menu.svg": 388,
	"./minus.svg": 247,
	"./mobile.svg": 396,
	"./multibanco.svg": 380,
	"./mute.svg": 627,
	"./phone.svg": 628,
	"./pin.svg": 629,
	"./play-circle-big.svg": 630,
	"./play-circle.svg": 619,
	"./plus.svg": 248,
	"./portions.svg": 631,
	"./purchases.svg": 785,
	"./search.svg": 390,
	"./select.svg": 386,
	"./send.svg": 404,
	"./stars.svg": 786,
	"./time.svg": 632,
	"./unmute.svg": 633,
	"./user.svg": 251,
	"./visa.svg": 787,
	"./visa_footer.svg": 402,
	"./watchlist.svg": 397,
	"./whatsapp.svg": 249,
	"./whatsapp_green.svg": 788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 617;